module.exports = __webpack_public_path__ + "static/media/k-12-square.2142b6d6.jpg";